import { useAtom } from '@reatom/npm-react'

import { userAtom } from '@root/entities/auth'
import { UserAvatar } from '@root/entities/auth/ui'
import { UserShort } from '@root/entities/user-short'
import { UserShortAvatar } from '@root/entities/user-short/ui/user-short-avatar'
import { useAppRoutes } from '@root/features/routing'

import { FollowUserButton } from '../../activity-actions'
import { ActivityKebabActions } from '../../activity-actions/activity-kebab-actions'

import { UserConnectionsItem } from './user-connections-item/user-connections-item'

import type { SearchUser } from '@root/entities/search-user'

interface UserConnectionsFollowerProps {
  follower: SearchUser.SearchUser & { deployedTokensCount: number | undefined }
  onNavigate?: () => void
}

export const UserConnectionsFollower = ({
  follower,
  onNavigate,
}: UserConnectionsFollowerProps) => {
  const { navigateUserProfile } = useAppRoutes()

  const [user] = useAtom(userAtom)
  const isAuthor = follower.delugeId === user?.delugeId
  const showName = isAuthor
    ? UserShort.someName(user)
    : UserShort.someName(follower)

  const handleNavigateToUserProfile = () => {
    navigateUserProfile(follower.delugeId)
    onNavigate?.()
  }

  return (
    <UserConnectionsItem
      avatar={
        isAuthor ? (
          <UserAvatar size={24} withPreview />
        ) : (
          <UserShortAvatar withPreview size={24} userShort={follower} />
        )
      }
      followers={follower.followersCount}
      following={follower.followingCount}
      coins={follower.deployedTokensCount}
      name={showName}
      key={follower.delugeId}
      delugeId={follower.delugeId}
      onNavigate={onNavigate}
    >
      <FollowUserButton
        delugeId={follower.delugeId}
        variant="soft"
        size="xs"
        radius="rounded"
        type="button"
      />
      <ActivityKebabActions
        userShort={follower}
        onNavigateToUserProfile={handleNavigateToUserProfile}
      />
    </UserConnectionsItem>
  )
}
